import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Inject, forwardRef } from '@angular/core';
import { Client, ISizeName } from '@df/core/service/client';
import { StylesService } from '@df/core/service/styles';
import { CarouselModule } from '@df/ui-carousel/carousel.module';
import { DfModal } from '@df/ui/modal/df-modal.decorator';
import { NDfModal } from '@df/ui/modal/df-modal.interface';
import { ModalRef } from '@df/ui/modal/modal-ref';
import { MODAL_DATA } from '@df/ui/modal/modal.service';
import { TranslationModule } from '@df/ui/translation/translation.module';
import { ProductComponent } from '../../../catalog/ui/product/product.component';
import { GtmImpressionTrackDirective } from '../../../module/gtm/gtm-impression-track.directive';
import { GtmTrackProductClickDirective } from '../../../module/gtm/gtm-track-product-click.directive';
import { ModalLayoutRightComponent, NModalLayoutRight } from '../../modal/modal-layout-right.component';
import { NShopThisLook } from '../shop-this-look.interface';

@DfModal({
    id: NShopThisLook.MODAL_ID,
    position: (size: ISizeName) => (size === 'S' ? 'bottom' : 'right'),
    config: (size: ISizeName) =>
        size === 'S'
            ? {
                  closeOnNavigation: true,
                  height: '80vh',
                  maxHeight: '650px',
                  width: '100vw',
                  hasBackdrop: true,
                  modalClass: 'p-a-0',
                  maxWidth: undefined,
                  position: {
                      bottom: '0',
                      right: '0',
                      left: '0'
                  }
              }
            : {
                  ...NModalLayoutRight.ModalConfig,
                  width: { S: StylesService.vw(100), M: StylesService.vw(72), L: '505px', X: '505px' }[size]
              },
    reopenPolicy: NDfModal.ReopenPolicy.last,
    sizeRestriction: sizeId => ({ S: ['S'], M: ['M', 'L', 'X'], L: ['M', 'L', 'X'], X: ['M', 'L', 'X'] })[sizeId]
})
@Component({
    templateUrl: './shop-this-look-modal.html',
    styleUrls: ['./shop-this-look-modal.scss'],
    standalone: true,
    imports: [
        CarouselModule,
        GtmImpressionTrackDirective,
        GtmTrackProductClickDirective,
        ModalLayoutRightComponent,
        NgClass,
        forwardRef(() => ProductComponent),
        TranslationModule
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ShopThisLookModalComponent {
    /**
     * Close shop-this-look
     */
    constructor(
        private modalRef: ModalRef<ShopThisLookModalComponent>,
        @Inject(MODAL_DATA) readonly data: NShopThisLook.IModalData,
        private client: Client
    ) {}

    /**
     * Close shop-this-look
     */
    close() {
        this.modalRef.close();
    }

    get pcSlides() {
        return this.data.products?.length === 1 ? 1 : [1.65, 1.65, 1.35, 1.35][this.client.sizeId];
    }

    get pcSlidesCeil() {
        return Math.ceil(this.pcSlides);
    }

    get pcGutter() {
        return '4px';
    }
}
